// extracted by mini-css-extract-plugin
export default {"month-calendar-head":"MonthCalendarHead_month-calendar-head__vohpv","day-of-week-header":"MonthCalendarHead_day-of-week-header__ej9Pk"};